import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators,FormControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { NotificationService } from './../../services/notification/notification.service';
import { TypeService } from './../../services/types/type.service';
// import { DataService } from 'src/app/services/data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as noty from 'noty';

// import { ContactSuccessComponent } from 'src/app/components/modals/contact-success/contact-success.component';
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  contactForm: FormGroup;
  types = [];

  constructor(
    private http:HttpClient,
    private formBuilder: FormBuilder,
    private _types: TypeService
  ){

  }

  ngOnInit(){

    this.contactForm = this.formBuilder.group({
      title: ['', Validators.required],
      suggestionType:['' , Validators.required],
      message: ['' , Validators.required],
      firstName:['',Validators.required],
      lastName:['',Validators.required],
      emailAddress:['',Validators.required],
      cellPhone:['',Validators.required],
      phone:['',Validators.required],
      chargeName:['',Validators.required],
      company:['',Validators.required],
      acceptInforPolicy: ['',Validators.required],
      state:['2',Validators.required]

    });


    this.getTypes();



  }

  get f() { return this.contactForm.controls; }

  onSubmit(){

    let values = this.contactForm.value;

    let data = {
      title: values.title,
      message:values.message,
      file:null,
      state:2,
      externalUser:{
        firstName: values.firstName,
        lastName:values.lastName,
        emailAddress:values.emailAddress,
        cellPhone:values.cellPhone,
        phone:values.phone,
        chargeName:values.chargeName,
        company:values.company,
        acceptInforPolicy:values.acceptInforPolicy,
        state:2
      },
      suggestionType: { id: values.suggestionType}

    }

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'text/plain',
      })
    };

    this.http.post('https://www.cotelco.org:8443/JSih/webresources/SuggestionREST/',data,httpOptions).subscribe((res:any) => {

     /* if (res.success) {
         new noty({
          text: 'Mensaje enviado',
          layout   : 'topRight',
          theme    : 'mint',
          type:'success'
        }).show();

        this.contactForm.reset();
      }*/

      this.contactForm.reset();


    })


  }

  getTypes(){
    this._types.getTypes().subscribe(res => {
      this.types = res;
    })
  }




}

